import { stringValidator } from '#validation/common/validators';
import { WORKSPACE_NAME_CONTENT_REGEX, WORKSPACE_NAME_END_REGEX, WORKSPACE_NAME_MAX_LENGTH, WORKSPACE_NAME_MIN_LENGTH, WORKSPACE_NAME_OPENAPI_REGEX, WORKSPACE_NAME_START_REGEX, } from '../constants';
export const workspaceNameValidator = stringValidator({
    requiredError: 'workspace.name.required',
    minLength: {
        min: WORKSPACE_NAME_MIN_LENGTH,
        error: 'workspace.name.minLength',
    },
    maxLength: {
        max: WORKSPACE_NAME_MAX_LENGTH,
        error: 'workspace.name.maxLength',
    },
    formats: [
        {
            regex: WORKSPACE_NAME_START_REGEX,
            error: 'workspace.name.startChar',
        },
        {
            regex: WORKSPACE_NAME_END_REGEX,
            error: 'workspace.name.endChar',
        },
        {
            regex: WORKSPACE_NAME_CONTENT_REGEX,
            error: 'workspace.name.invalidChar',
        },
    ],
    openApiFormat: WORKSPACE_NAME_OPENAPI_REGEX,
});
